import {useQuery} from "@tanstack/react-query";
import React from "react";
import {AccountSearchInterface} from "../../correspondent/list/interface/searchInterface";
import {readPtaTierListApi} from "../../../../api/correspondent/tierApi";

type Props = {
    searchOption: AccountSearchInterface;
};

export const useReadPtaTierList = ({searchOption}: Props) => {
    const {data} = useQuery({
        queryKey: ["readPtaTierList", searchOption],
        queryFn: async () => await readPtaTierListApi(searchOption),
        select: (res) => res?.result,
        // staleTime: 6000 * 10,
    });

    return {data};
};
